module.exports = __webpack_public_path__ + "img/invalid-left.e120a9c4.svg";